module.exports = __webpack_public_path__ + "static/media/APP_MotherTeresa_152x174_3.84b82692.png";